import {APP_NAME} from "./Constant";

export default class ApiConstants {
  static URL = {
    BASE: process.env.REACT_APP_BASE_URL,
    TABLE: {
      GET_ALL: `v1/crm/core/table`,
      GET: (tableId) => `v1/crm/core/table/${tableId}`,
      ADD_COLUMN: (tableId) => `v1/crm/core/table/${tableId}/column`,
      ADD_RECORD: (tableId) => `v1/crm/core/table/${tableId}/record`,
      GET_RECORD: (tableId) => `v1/crm/core/table/${tableId}/record`,
      GET_RECORD_BY_PAGE: (tableId) =>
        `v1/crm/core/table/${tableId}/paged-record`,
      UPDATE_RECORD: (recordId, tableId) =>
        `v1/crm/core/table/${tableId}/record/${recordId}`,
      GET_RECORD_BY_ID: (recordId, tableId) =>
        `v1/crm/core/table/${tableId}/record/${recordId}`,
      DELETE_RECORD: (recordId, tableId) =>
        `v1/crm/core/table/${tableId}/record/${recordId}`,
      DELETE_BULK_RECORD: (tableId) => `v1/crm/core/table/${tableId}/record`,
      DELETE_COLUMN: (columnId, tableId) =>
        `v1/crm/core/table/${tableId}/column/${columnId}`,
      UPDATE_COLUMN: (columnId, tableId) =>
        `v1/crm/core/table/${tableId}/column/${columnId}`,
      SHIFT_COLUMN: (tableId) => `v1/crm/core/table/${tableId}/save-col-order`,
      ADD_BULK_RECORD: (tableId) => `v1/crm/core/table/${tableId}/record-bulk`,
      UPDATE_BULK_RECORD: (tableId) =>
        `v1/crm/core/table/${tableId}/record-bulk`,
      ADD_TABLE: `v1/crm/core/table`,
      STAGE_META: `v1/crm/core/candidate/stage-metadata`,
      CANDIDATE_RECORD_BY_PAGE: `v1/crm/core/candidate/paged-record`,
    },
    SETTINGS: {
      USER: `v1/crm/core/settings/user`,
    },
    IAM: {
      REDIRECT: process.env.REACT_APP_LOGIN_URL,
      LOG_OUT: `v1/iam/auth/logout2`,
      STATUS: `v1/iam/auth/sign-in/login/status`,
      SWITCH_TENANT: `v1/iam/users/web/switch-tenant`,
      TFA_STATUS: `v1/iam/auth/sign-in/web/mfa-status`,
      ENABLE_TFA: `v1/iam/auth/sign-in/web/mfa-enable`,
      DELETE_TFA: `v1/iam/auth/sign-in/web/mfa`,
      ADD_USER: `v1/iam/users/tenants/roles`,
      UPDATE_USER: `v1/users/update/info`,
      CHANGE_PASSWORD: `v1/iam/users/change-password`,
      CODE_TFA: `v1/iam/auth/sign-in/web/mfa`,
      RESEND_VERIFICATION_MAIL: `v1/iam/auth/email/regenerate`,
      REFRESH_TOKEN: `v1/iam/auth/web/getrefreshtoken`,
      IDLE_TIMEOUT_TOKEN_EXPIRY: `v1/iam/token/idletimeouttokenexpiry`,
      SSO_REFRESH_TOKEN: `v1/iam/auth/web/sso-apps/getrefreshtoken`
    },
    AUTH: {
      VERIFY_EMAIL: `email/verification`,
    },
    SUBENGINE: {
      SUBSCRIPTION_PEOPLE: `v1/subengine/subscription/people`,
      PLAN: "v1/subengine/subscription?Version=v2",
      START_TRAIL: "v1/subengine/subscription",
    },

    USER: {
      ROLES: `v1/users/roles`,
      DELETE_REASON: `v1/iam/users/account/`,
      DETAIL: `v1/users/users/count`,
      USER_INFO: `v1/users/userinfo`,
      USER_INFO_BY_ID: `v1/users/userinfo?query=id=`,
      TENANTS: `v1/users/tenants`,
      DUPLICATE_CONTACT: `v1/people/tenants/email/validate`,
      USERS: `v1/expenses/users/list`,
      USER_BY_IAM:iamUserId=> `v1/people/users/iam/${iamUserId}`
    },
    TENANT: {
      GET_DETAILS: `v1/tenants/details`,
      CLIENT_DETAILS: `v1/tenants/bookkeeper/client-tenants`,
      COMPANY_NAME: `v1/tenants/TENANT_ID/settings/name`,
      RESET_COMPANY: `v1/tenants/reset`,
      DELETE_COMPANY: `v1/tenants/`,
      PAYMENT: `v1/tenants/bookkeeper/payment`,
      ORG_WITHOUT_SETUP: `v1/tenants/**/organisationwithoutsetup`,
      TENANTS: `v1/users/tenants`,
      COMPONENT_GROUP: `v1/people/tenants/component-group`,
      ADD_ORG: `v1/tenants/organisation`,
      ERP_TENANT: `v1/tenants`,
      DEFAULT_TEMPLATE: `v1/people/tenants/default-templates`
    },
    PUBLIC_PAGE: {
      GET_JSON_DATA: (id) => `v1/crm/core/deskera/open/${id}`,
    },
    SMTP: {
      SETUP: `v1/crm/emails/campaign/setup`,
      GET_ALL_SETUPS: `v1/crm/emails/campaign/setup?app_name=CRM3`,
      SETUP_WITH_ID: (id) => `v1/crm/emails/campaign/setup/${id}`,
    },
    IMPORT_EXPORT: {
      UPLOAD_FILE: `v1/attachment/file-upload`,
      UPLOAD_RECORDS: `v1/exim/people3/import`,
      AUDIT_LOG: `v1/exim/audit`,
      EXPORT_FILE: (tableId) => `v1/crm/core/table/${tableId}/export`,
      UPLOAD_FILE_PUBLIC: `v1/attachment/file-upload/public`,
      DOWNLOAD_FILE: `v1/attachment/file-download`,
      EXPORT_PAYRUN: "v1/exim/payrun/export",
      PAYSTUB_DOWNLOAD: "v1/people-pay-run/payslips/paystub/",
      EXIM: "v1/exim",
      COMPLIANCE: (userId, form) =>
        `v1/people/compliance/export/${userId}/${form}`,
      COLUMN_MAPPING: "v1/exim/column-mapping",
      IMPORT: "v1/exim/import",
    },
    ATTACHMENT: {
      UPLOAD: `v1/attachment/upload`,
      GET_ALL: (entityId, entityName) =>
        `v1/attachment/getAttachments?entityId=${entityId}&entityName=${entityName}`,
      DOWNLOAD: (attachmentId) =>
        `v1/attachment/download?attachmentId=${attachmentId}&entityName=EXPENSE`,
      DELETE: (attachmentId) =>
        `v1/attachment/delete?attachmentId=${attachmentId}`,
      UPDATE: `v1/attachment/update`,
    },

    CUSTOM_DOMAIN: {
      DOMAIN_URL: `v2/crm/guide/custom-domain`,
    },
    PAYROLL: {
      GET_PAYROLL: `v1/people-pay-run/payruns`,
      GET_WORKWEEK: `v1/people/tenants/workweek`,
      GET_PAYSCHEDULELIST: `v1/people-pay-schedule/pay-schedules/tenant`,
      GET_USERS: `v1/people/users`,
      USER: "v1/people/users/login/info",
      PROCESS_PAYROLL: `v1/people-pay-run/payruns/status`,
      PAYSTUB: "/v1/people-pay-run/paystubs",
      REVERT: (payrunId) => `v1/people-pay-run/payruns/revert/${payrunId}`,
      FILTER_USER: "v1/people/users/filtered-users",
      FILTERED_PAYROLL: `v1/people-pay-run/payruns/filtered-payrun`,
      FILTERED_PAYSCHEDULE: `v1/people-pay-schedule/pay-schedules/filtered-payschedule`,
      DOWNLOAD_PTS_FILE: (payrunId) => `v1/people/compliance/payroll-us/master-tax/pts?payrunId=${payrunId}`
    },
    PEOPLE: {
      ATTENDANCE: `v1/people/attendance`,
      ATTENDANCE_FILTERED: 'v1/people/attendance/filtered',
      PROXY_ATTENDANCE: `v1/people/attendance/proxy`,
      SELF: `v1/people/attendance/self`,
      ATTENDANCE_SELF: 
        `v1/people/attendance/self`,
      TENANT: "v1/people/tenants",
      CONFIG: "v1/people/tenants/configuration",
      USER: "v1/people/users/login/info",
      PAY_SCHEDULE: `v1/people-pay-schedule/pay-schedule`,
      DESIGNATION: "v1/people/users/designations",
      COMPONENT: "v1/people-component/",
      PAY_SCHEDULE_BASE: "v1/people-pay-schedule",
      BANK: "v1/people/tenants/banks",
      NOTIFICATION_SETTINGS: "v1/people/tenants/notification-settings",
      ATTENDANCE_EXPORT: "v1/exim/attendance/export",
      ATTENDANCE_PUNCHLOG_EXPORT: "v1/exim/attendance/export/punchlog",
      BANK_DETAILS:(countryCode)=> `v1/people/tenants/banks-details?countryCode=${countryCode}`,
      USERS: `v1/people/users`,
      FROM_TO_PAY_PERIOD: `v1/people-pay-schedule/pay-schedule/from-to-basis-payperiod`,
      TEAMS: {
        LIST: "v1/people/tenants/teams/list"
      },
      USER_SHORT_INFO: "v1/users/userinfo/short"
    },
    CASHFREE: {
      LINK_ACCOUNT: `v1/people/payment/verification/link_account`,
      GET_ACCOUNTS: `v1/people/payment/verification/fetch_accounts`,
      UPDATE_ACCOUNT: `v1/people/payment/verification/update_account`,
      VERIFY_IFSC_ACCOUNT_NUMBER: `v1/people/payment/verification/bankDetails`,
      SYNC_BENEFICIARIES: `v1/people/users/sync-beneficiaries`,
      RETRY_PAYMENT: (payrunId) =>
        `v1/people-pay-run/payruns/process-payment/${payrunId}`,
    },
    EMPLOYEE: {
      DELETE_EMPLOYEE: `v1/people/users/delete/bulk`,
      GET_HOLIDAYS: `v1/people/tenants/holidays`,
      GET_EMPLOYEE_META: (countryCode) =>
        `v1/people/compliance/${countryCode}/employee-meta?isFromNewSetup=true`,
      SAVE_EMPLOYEE: `v1/people/users`,
      EMPLOYEE_SERVICE: "/v1/people-employees",
      GET_DETAILS: (userId) => `/v1/people/users/${userId}`,
      GET_TAX_DETAILS: (countryCode) =>
        `/v1/people/compliance/${countryCode}/tax-applicable`,
      GET_BANK_DETAILS: (countryCode) => `/v1/people/tenants/banks-details?countryCode=${countryCode}`,
      GET_CPF_ACCOUNTS: `v1/people/tenants/accounts/list`,
      ADD_ACCOUNT: `v1/people/tenants/account`,
      UPDATE_ACCOUNT: `v1/people/tenants/account`,
      DELETE_ACCOUNT:(accountId) => `v1/people/tenants/account/${accountId}`,
      SHORT_INFO: `v1/people/users/shortinfo`,
      FIELD_CONFIG: `v1/people/tenants/field-config`,
      FIELD_PERMISSIONS: `v1/people/tenants/role-field-permissions`,
      ROLE_PERMISSIONS: `v1/people/tenants/permissions/role-setting`,
    },
    COMPLIANCE: {
      BASE: "v1/people/compliance",
      IN: {
        GET_IT_DECLARATION_CONFIG: "v1/people/tenants/configuration",
        GET_TAX_DECLARATION_ITEMS:
          "v1/people/compliance/IN/tax-declaration-items",
        GET_IT_DECLARATION: "v1/people-employees/in/tax-declaration-info",
        POST_IT_DECLARATION: "v1/people-employees/in/tax-declaration-info",
        PUT_IT_DECLARATION: "v1/people-employees/in/tax-declaration-info",
        GET_TAX_ESTIMATE: "v1/people/compliance/IN/tax-estimate",
        GET_TAX_ESI: "v1/people/compliance/IN/tax-esi-rate",
        GET_IN_TAX_DETAIL: "v1/people/tenants/IN/tax",
        DELETE_TAX_DECLARATION:"v1/people-employees/in/tax-declaration-info",
        TOGGLE_INTEGRATION_MAPPING:
          "v1/people/tenants/toggle-integration-mapping",
        GET_INTEGRATION_MAPPING: "v1/people/tenants/integration-mapping",
        GET_EXPENSE_AND_LIABILITY_ACCOUNTS:
          "v1/account?accountGroups=Expenses,Current Liabilities,Other Expenses&checkOpeningEditable=false&limit=500&page=0",
      },
      US: {
        SEARCH_ADDRESS: "v1/tax-calc/address/searchwithfilters",
        DOWNLOAD_US_STATE_FORM: (formType) => `v1/people/compliance/us-forms/${formType}`,
        PLAID: {
            CREATE_LINK_TOKEN: "v1/people/payment/bank/verifications/create_link_token",
            SET_ACCESS_TOKEN: "v1/people/payment/bank/verifications/set_access_token",
            VERIFY_ACCOUNTS: "v1/people/payment/bank/verifications/verify_accounts"
        },
        GET_FORM_DATA: "v1/people/compliance/sign-form/us",
        GET_FORM_DATA_EMPLOYEE: "v1/people/compliance/sign-form/us/employee",
        GET_FORM: "v1/people/compliance/export/us/auth",
        SIGN_FORM: "v1/people/compliance/sign-form/us/"
      },
      COMPONENT: {
        GET:(countryCode) =>`v1/people/compliance/${countryCode}/components`
      }
    },
    REPORT: {
      PAYROLL_LIABILITY_REPORT: "v1/people-pay-run/paystubs/report/liability",
      GET_FORMS_FIELDS: (country, state) =>
        `v1/people/compliance/${country}/state-taxes-meta/${state}`,
      GET_FORMS_FIELDS_EMPLOYEE: (country, state, employeeId) =>
        `v1/people/compliance/${country}/state-taxes-meta/${state}/employee/${employeeId}`,
      GET_ACTIVITIES_BY_CONTACT: `v1/crm/core/report/activities-group-by-contact`,
      GET_TICKETS_BY_CONTACT: `v1/crm/core/report/tickets-group-by-contact`,
      GET: `v1/reports-builder/reports`,
      GET_TABLE_DATA: `v1/reports-builder/data-source/report-tables`,
      EXECUTE: `v1/reports-builder/reports/execute-v1`,
      REPORT_BUILDER: (id) => `v1/reports-builder/reports/${id}`,
      SEND_EMAIL: "v1/reports-builder/reports/email-v1",
      EXPORT_DATA: "v1/reports-builder/reports/export-v1",
      STATUTORY_REPORT:(countryCode)=> `v1/people/compliance/export/${countryCode}/statutory-form`,
      COMPLIANCE_REPORT:(countryCode) =>`v1/people/compliance/${countryCode}/report`,
      COMPLIANCE:'v1/people/compliance/export',
      CPF: {
        DOWNLOAD_CPF_REPORT: `v1/people/compliance/payroll-singapore/esubmission`,
        DOWNLOAD_IRAS_REPORT: `v1/people/compliance/payroll-singapore/ir8a`,
        DOWNLOAD_IRAS_SUBMISSION_REPORT: `v1/people/compliance/payroll-singapore/esubmission/iras`
      },
      TDS: {
        GET:(userId,month,year)=> `v1/people/compliance/IN/tds-sheet/${userId}/${month}/${year}`
      },
      IRAS: {
        DOWNLOAD_REPORT: (userId, reportType) => `v1/people/compliance/export/IRAS-form/${reportType}/${userId}`,
        IRAS_E_SUBMISSION: `v1/people/compliance/payroll-singapore/esubmission/iras`,
        MAP_COMPONENTS : {
            GET_COMPONENTS: 'people-component/components/tenant',
            GET_CATEGORY_MAPPING: (countryCode) => `v1/people/compliance/${countryCode}/components/category-mapping`,
            GET_MASTER_DATA: (countryCode) => `v1/people/compliance/${countryCode}/components/category`,
            POST_MAPPED_COMPONENTS: 'v1/people/compliance/components/category-mapping',
            PUT_MAPPED_COMPONENTS: 'v1/people/compliance/components/category-mapping',
        },
        GET_SUBMISION_DETAILS: `v1/people/compliance/iras/ais_summary`,
        GET_SUBMITTED_DETAILS: `v1/people/compliance/iras/ais_summary/submitted`,
        POST_VALIDATION: `v1/people/compliance/ais/getAuthenticationUrl`,
        POST_AUTHORIZATION:(params, isFromNewSetup) => `v1/people/compliance/ais/ais-submission?${params}&isFromNewSetup=${isFromNewSetup}`,
        GET_SUBMISSION_LOG: `v1/people/compliance/iras/ais_summary/logs`,
        GET_REPORT: (countryCode, userId) => `v1/people/compliance/${countryCode}/report/${userId}`,
        UPDATE_FORM: (record_id) => `v1/people/compliance/report/IRAS/summary/${record_id}`
      },
      APPENDIX_8A: {
        GET:(userId) => `v1/people/compliance/SG/IRAS-form/APPENDIX_8A/${userId}`,
        SAVE: `v1/people/compliance/SG/IRAS/APPENDIX_8A`
      },
      IR8S: {
        GET:(userId)=> `v1/people/compliance/SG/${userId}/IRAS-form`,
        SAVE:`v1/people/compliance/SG/IRAS-form`
      },
      APPENDIX_8B: {
        GET:(userId) => `v1/people/compliance/SG/IRASForm/APPENDIX_8B/${userId}`,
        SAVE: `v1/people/compliance/SG/IRASForm/APPENDIX_8B`
      },
      WAGE_REGISTER: {
        GET:(month,year) => `v1/people-pay-run/pdf/get-wagereg?month=${month}&year=${year}`
      },
      FORM16: {
        USERS:(year)=>`v1/people/users/form16/${year}`,
        GENERATE:(year,formType)=>`v1/people-pay-run/payruns/form-16/${year}?formType=${formType}`
      }
    },
    NOTIFICATION: {
      GET_ALL: "v1/crm/bell-notifications",
    },
    CUSTOM_FIELD: {
      GET: "v1/people/tenants/custom-fields",
    },
    GEO_LOCATION: {
      VIEW_LOCATION: (latitude, longitude) =>
        `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
    },
    DOCUMENT: {
      PRINT_INFO_TEMP: "v1/template/people-print-info/",
      PRINT_INFO: "v1/template/people-template-print-info",
      CHECK_PRINT_INFO: "v1/template/people-check-print-info",
      PRINT_INFO_CHECK: "v1/template/people-print-info/cheque",
      PRINT_DOC_BY_ID: (uid) =>
        `v1/template/print-info/print-design-doc-by-uid/${uid}`,
      DEFAULT_TEMPLATE:(tid) => `v1/template/document/set-default/${tid}`
    },
    CURRENCY: {
      GET_ENUM: `v1/multicurrency/getCurrencyEnum`,
    },
    WORKFLOW: {
      GET_CONNECTIONS: `v1/workflow/connection`,
      CREATE_CONNECTION: `v1/workflow/connection-internal`,
      EMAIL_VERIFICATION: `v1/crm/campaign/email-verification`,
      FLOW_EXEC: `v1/workflow-engine-people/flow/exec`,
      EXPENSE_GROUP_ACTIVE: 'v1/workflow-engine-people/flow/expense-group/active',
      UPDATE_EXPENSES: `v1/expenses/approval-data/update`,
      UPDATE_TIME_OFF: `v1/eleave/applications/leave/approval-data/update`
    },
    CURRENCY: {
      GET_ENUM: `v1/multicurrency/getCurrencyEnum`,
    },
    EXPENSE: {
      CATEGORY: "v1/expenses/admin/categories",
      EXPENSES: "v1/expenses",
      EXPENSES_BREAKDOWN: "v1/expenses/breakdown",
      TAXES: "v1/taxes",
      GET_EXPENSES: "v1/expenses",
      PATCH_INTEGRATION_TOGGLE: (status) =>
        `v1/expenses/toggle-integration-mapping/${status}`,
      GET_INTEGRATION_MAPPING: `v1/expenses/integration-mapping`,
      SYNC_REVERT_JE: (action) => `v1/expenses/je/${action}`,
      UPLOAD: "v1/expenses/receipt/upload",
      IMAGE: "v1/expenses/process/image",
      POST_INTEGRATION_SETTINGS: ``,
      GROUP: `v1/expenses/group`,
      BULK_USER: `v1/expenses/bulkUser`,
      GET_USER_BY_GROUP_ID: (id) => `v1/expenses/group/${id}/users`,
      USER: `v1/expenses/user`,
      MOVE_USER: `v1/expenses/moveUser`,
      APPROVE_EXPENSE: "v1/expenses/update",
      GET_CATEGORY: "v1/expenses/category",
      SYNC_REVERT_JE: (action) => `v1/expenses/je/${action}`,
      CLAIMS_BY_TREND: `v1/expenses/trend`,
      GET_USER_ROLES: `v1/expenses/userroles`,
      STATUS: `v1/expenses/status`,
      GET_NO_GROUP_USERS: "v1/expenses/roles/users",
      MULTI_EXPENSE: "v1/expenses/multi",
      USER_EXPENSE_GROUP: "v1/expenses/userInfo/group",
      POST_LIMIT_POLICY: "v1/expenses/limit",
      UPDATE_LIMIT_POLICY: "v1/expenses/limit",
      FETCH_EXPENSE_POLICY_LIST: "v1/expenses/limit/list",
      DELETE_EXPENSE_POLICY_LIST: "v1/expenses/limit/delete"
    },
    LOCATION: {
      GET_LOCATION_LIST: `v1/dimension/location`,
      GET_LOCATION_DIMENTION_LIST: `v1/dimension`,
      UPDATE_LOCATION: (id) => `v1/dimension/location/${id}`,
      GET_NO_GROUP_USERS: 'v1/expenses/roles/users',
      GET_LOCATION_LIST: `v1/dimension/location`,
      MULTI_EXPENSE: 'v1/expenses/multi'
    },
    CHECKHQ: {
      GET_COMPONENT_LINK: "v1/people/tenants/check/component",
      GET_COMPANY_AND_INDUSTRY_TYPE:
        "v1/people/tenants/business-classifications",
      SYNC_CHANGES: "v1/people/tenants/check-hq/sync",
    },
    GEO_FENCING:{
      GEO_LOCATION: `v1/people/users/geofencing/locations`,
      PLANS: `v1/people/tenants/geofencing/plans`,
      GEO_CODE_REVERSE:(lat,lng,key)=> `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${key}`,
      GEO_LOCATION_MAPPING: `v1/people/users/geolocation/mappings`
    },
    PERFORMANCE: {
      APPRAISAL_LIST: "v1/people/performance-appraisal/settings/appraisal-list",
      REVIEWER_APPRAISAL_LIST: "v1/people/performance-appraisal/settings/reviewer-appraisal-list",
      SAVE_APPRAISAL: "v1/people/performance-appraisal/settings",
      APPRAISAL_REVIEWS: "v1/people/performance-appraisal/reviews",
      RATINGS: "v1/people/performance-appraisal/assessment/ratings",
      SELF_ASSESSMENT: "v1/people/performance-appraisal/assessment/self-assessment",
      REVIEW_ASSESSMENT: "v1/people/performance-appraisal/assessment/review-assessment",
      SETTINGS: "v1/people/performance-appraisal/settings",
      GOALS: "/v1/people/performance-appraisal/goals"
    },
    GIRO: {
      GIRO_LIST: 'v1/people-pay-run/payruns/giro/file',
      PAYMENT_DETAILS: 'v1/people/compliance/giro/payment-details/payrun',
      GENERATE_GIRO: 'v1/people/compliance/giro/payment-details'
    },
    BANK_ACCOUNT: {
        GET_BANK_ACCOUNTS: "v1/people/tenants/banks",
        GET_BANK_DETAILS: "v1/people/tenants/banks-details",
        SAVE_BANK_ACCOUNT: "v1/people/tenants/banks"
    },
    GET_PAYMENT_LOGS: "v1/people/compliance/giro/payment-details",
    SHIFTS: {
        GET: "v1/people/tenants/shifts",
        ADD: "v1/people/tenants/shifts",
        UPDATE: "v1/people/tenants/shifts",
        DELETE: "v1/people/tenants/shifts/delete"
    },
    USER_TAX_DETAILS: {
        FETCH: "v1/people/users/MY/taxDetails/list",
        POST: "v1/people/users/MY/taxDetails",
        PUT: "v1/people/users/MY/taxDetails"
    },
    OVERTIME: {
      OVERTIME_POLICY: "v1/people/tenants/overtime",
      OVERTIME_POLICY_BY_ID:(id)=> `v1/people/tenants/overtime/${id}`,
      OVERTIME_MULTIPLIER: "v1/people/tenants/overtime/ot-multiplier",
      OVERTIME_FIND: "v1/people/tenants/overtime/find"
    },
    COMP_OFF: {
        FETCH_CONFIGURATION: "v1/eleave/management/compoff-setting",
        POST_CONFIGURATION:"v1/eleave/management/compoff-setting",
        UPDATE_CONFIGURATION: "v1/eleave/management/compoff-setting",
        SAVE_INITIALIZED_COMPOFF: "v1/eleave/management/compoff",
        UPDATE_INITIALIZED_COMPOFF: "v1/eleave/management/compoff",
        GET_INITIALITED_COMPOFF_LIST: "v1/eleave/management/compoff-filter",
        DELETE_INITIALISED_COMP_OFFS : "v1/eleave/management/compoff",
        EMPLOYEE_APPLIED_COMP_OFF_FILTER: "v1/eleave/management/employee-compoff-filter",
        UPDATE_EMPLOYEE_APPLIED_COMP_OFF_STATUS: "v1/eleave/management/employee-compoff/status",
        EMPLOYEE_APPLIED_COMP_OFF: "/v1/eleave/management/employee-compoff",
        GET_BY_USER_ID:(id)=> `/v1/eleave/management/compOff/${id}`,
        SAVE_EMPLOYEE_COMP_OFF: 'v1/eleave/management/employee-compoff',
        LEAVE_DETAILS: 'v1/eleave/applications',
        LEAVES: `v1/eleave/management/leaves`
    },
    AUDIT_LOG: {
        GET: "v1/people/tenants/audit-logs"
    },
    BOOKS: {
      CONTACTS: "v1/contacts",
      CONTACTS_BRIEF: "v1/contacts/brief-details"
    },
    TIMESHEET: {
      PROJECT_LIST: "v1/people/projects/list",
      PROJECTS: "v1/people/projects",
      TASK_LIST: "v1/people/projects/jobs/list",
      TASK: "v1/people/projects/jobs",
      EMPLOYEE_MAPPING: "v1/people/projects/billing-rate",
      EMPLOYEE_MAPPING_LIST: "v1/people/projects/billing-rate/list",
      GET_TIMESHEET: "v1/people/projects/timesheet/list",
      SAVE_TIMESHEET: "v1/people/projects/timesheet",
      UPDATE_TIMESHEET: "v1/people/projects/timesheet",
      DELETE_TIMESHEET: "v1/people/projects/timesheet",
      SUBMIT: 'v1/people/projects/timesheet/submit',
      GET_REPORT: "v1/people/projects/report",
      GET_GROUP_REPORT: "v1/people/projects/report/group",
      CREATE_INVOICE: "v1/people/projects/invoice",
      GET_ADMIN_CALENDER_REPORT: "v1/people/projects/report/calendar",
      DRAFT: 'v1/people/projects/timesheet/draft'
    },
    BIOMETRIC_ATTENDANCE : {
        GET_FIELD_CONFIG : `v1/people/attendance/biometric/list`,
        SAVE_ATTENDANCE_DETAILS : `v1/people/attendance/biometric/add`,
        GET_ATTENDANCE_DETAILS : `v1/people/attendance/biometric/detail`,
        DELETE_ATTENDANCE_DETAILS : `v1/people/attendance/biometric/delete`,
        SYNC_BIOMETRIC_ATTENDANCE: "v1/people/attendance/biometric/process"
    },
    PERMISSION: {
        GET_MODULES:(countryCode) => `v1/people/users/permissions/${countryCode}/modules`,//
        GET_ROLES: "v1/people/users/permissions/roles",
        ADD_ROLE: "v1/people/users/permissions/roles",
        UPDATE_ROLE: "v1/people/users/permissions/roles",
        DELETE_ROLE: "v1/people/users/permissions/roles",
        GET_USER_ROLE: "v1/people/users/permissions/roles",
        GET_USER_ROLES: "v1/people/tenants/permissions/list",
        ASSIGN_ROLE: "v1/people/users/permissions/assign",
        CHANGE_ASSIGN_ROLE: "v1/people/users/permissions/assign"
    },
    MODULE_ACCESS_CONTROL: {
      GET: `/v1/people/users/permissions/module`,
      SAVE: `/v1/people/users/permissions/module`
    },
    WORKDAY: {
      SIGN_IN: `/v1/iam/auth/sign-in/web/workday-signin`
    },
    POLICY_AND_RESOURCES: {
      GET: "/v1/people/tenants/documents",
      POST: "/v1/people/tenants/documents",
      DELETE: "/v1/people/tenants/documents"
    },
    INVITE: {
      GET_INVITED_USER: `v1/users/books/invite?appName=${APP_NAME}`,
      INVITE_USER: `v1/users/books/invite`,
      CANCEL_INVITE: (inviteId) => `v1/users/books/invite/cancel/${inviteId}`
    },
    CUSTOM_SECTION: {
      DROPDOWN: {
        GET_FIELDS: `v1/people/tenants/custom-fields/options`,
        UPDATE_OPTIONS: `v1/people/tenants/custom-fields/update-options`,
      }
    }
  };

  static ACCESS_TOKEN = null;
  static LOCALHOST_URL = "localhost:3000";

  static PRODUCT_URL_GO = process.env.REACT_APP_URL_GO;
  static PRODUCT_URL_ERP = process.env.REACT_APP_URL_ERP;
  static PRODUCT_URL_CRM = process.env.REACT_APP_URL_CRM;
  static PRODUCT_URL_PEOPLE = process.env.REACT_APP_URL_PEOPLE;
  static PRODUCT_URL_WEBSITE_BUILDER = process.env.REACT_APP_URL_WEBSITE_BUILDER;
  static PRODUCT_URL_SHOP = process.env.REACT_APP_URL_SHOP;
  static PRODUCT_URL_REPORT_BUILDER = process.env.REACT_APP_URL_REPORT_BUILDER;
  static PRODUCT_URL_DOCUMENT_BUILDER = process.env.REACT_APP_URL_DOCUMENT_BUILDER;
  static PRODUCT_URL_WORKFLOW_ENGINE = process.env.REACT_APP_URL_WORKFLOW_ENGINE;
  static PRODUCT_URL_ELEAVE = process.env.REACT_APP_URL_ELEAVE;
  static PRODUCT_URL_EXPENSE = process.env.REACT_APP_URL_EXPENSE;
  static AUTH_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL;

  static CASHFREE_WHITELIST_IP = process.env.REACT_APP_URL_WHITELISTED_IP;
  static CASHFREE_WEBHOOKS = process.env.REACT_APP_URL_WEBHOOK_URL;
  static CASHFREE_WHITELIST_REDIRECT = process.env.REACT_APP_URL_WHITELIST_REDIRECT;
  static CASHFREE_WEBHOOKS_REDIRECT = process.env.REACT_APP_URL_WEBHOOKS_REDIRECT;
  static PRODUCT_URL_WEBSITE = process.env.REACT_APP_URL_WEBSITE;

//   static COMPLIANCE_COUNTRY = process.env.REACT_APP_COMPLIANCE_COUNTRY;
  static EMPLOYEE_LOGIN_REDIRECT = process.env.REACT_APP_EMPLOYEE_LOGIN_REDIRECT === "true";
  static SWITCH_NEW_WINDOW = process.env.REACT_APP_SWITCH_NEW_WINDOW === "true";
  static AUTOSAVE_INTERVAL = process.env.REACT_APP_AUTOSAVE_INTERVAL;
  static LOADING_MASK_DELAY = process.env.REACT_APP_LOADING_MASK_DELAY;
  static SUBSCRIPTON_SUCCESS_INTERVAL = process.env.REACT_APP_SUBS_SUCCESS_INTERVAL;
  static EXPENSE_REFRESH_INTERVAL = process.env.REACT_APP_EXPENSE_REFRESH_INTERVAL;
  static EXPENSE_REFRESH_COUNT = process.env.REACT_APP_EXPENSE_REFRESH_COUNT;

  static URL_MOBILE_IOS = "https://apps.apple.com/app/desk-business-and-accounting/id1463523833?ls=1";
  static URL_MOBILE_ANDROID = "https://play.google.com/store/apps/details?id=com.deskera.desk";

  //static FORM_EMBEDDED_URL = "https://js-bucketnew.s3.ap-southeast-1.amazonaws.com/embed.js"
  static FORM_SUBMISSION_URL = "https://js-bucketnew.s3.ap-southeast-1.amazonaws.com/FormSubmission.js";
  static LOAD_SCRIPTS_URL = "https://js-bucketnew.s3.ap-southeast-1.amazonaws.com/LoadScript.js";
  static MULTI_PAYMENT = process.env.REACT_APP_URL_MULTI_PAYMENT;

  static PRODUCT_URL_EXPENSES = process.env.REACT_APP_URL_EXPENSES;
  static IS_EXPENSES_ENABLED = process.env.REACT_APP_EXPENSES_ENABLED;
  static CURRENT_ENVIRONMENT = process.env.REACT_APP_ENVIRONEMENT;
  static STATUS_RETRY_COUNT = process.env.REACT_APP_STATUS_RETRY_COUNT;
  static US_COMPLIANCE_STATES = eval(process.env.REACT_APP_US_COMPLIANCE_STATES);
  static SHIFT_OVERTIME_PLANS = eval(process.env.REACT_APP_SHIFT_OVERTIME_PLANS);
  static AIS_APPLICATION_REDIRECT_URL = process.env.REACT_APP_AIS_REDIRECT_URL;
  static ROUTE_TO_IRAS_AMMENDMENT = process.env.REACT_APP_ROUTE_TO_APPENDMENT_IRAS;

  static TALK_TO_SALES_URL = ApiConstants.PRODUCT_URL_WEBSITE + "/contact-us?prefilltext=I want to know more subscription to peopleplus";
  static IDLE_TIMER_ID = process.env.REACT_APP_IDLE_TIMER_ID;
  static COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN;
  static AUTO_LOGOUT_TIME = eval(process.env.REACT_APP_AUTO_LOGOUT_TIME);
  static DESKERA_APP_LINK_ENABLED = eval(process.env.REACT_APP_DESKERA_APP_LINK_ENABLED);
}
